export default "__VITE_ASSET__D797CqpW__"